
<template>
    <div class="m-portlet m-portlet--head-sm" :class="{'m-portlet--collapse' : !isOpen }"  m-portlet="true">
        <div class="m-portlet__head preview">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">{{ labels.product_claims }}</h3>
                </div>
            </div>
            <div class="m-portlet__head-tools">
                <div class="m-portlet__head-tools">
                    <ul class="nav nav-tabs m-tabs-line m-tabs-line--primary" role="tablist" @click="togglePortlet('open')" style="border: none;">
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link active show" data-toggle="tab" :href="'#m_tabs_claim_1' + previewProduct.productId" role="tab" aria-selected="true" style="border: none;">
                                {{ labels.efficiency_title }}
                            </a>
                        </li>
                        <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" :href="'#m_tabs_claim_2' + previewProduct.productId" role="tab" aria-selected="false" style="border: none;">
                                {{ labels.security_title }}
                            </a>
                        </li>
                    </ul>
                </div>
                <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item">
                        <a @click.prevent="togglePortlet" m-portlet-tool="toggle" class="m-portlet__nav-link m-portlet__nav-link--icon" aria-describedby="tooltip_3xmztoxj1y"><i class="la la-angle-down"></i></a>
                        <div class="m-tooltip m-tooltip--portlet tooltip bs-tooltip-top" role="tooltip" aria-hidden="true" x-placement="top" style="position: absolute; will-change: transform; visibility: hidden; top: 0px; left: 0px; transform: translate3d(288px, -32px, 0px);">
                            <div class="tooltip-arrow arrow" style="left: 39px;"></div>
                            <div class="tooltip-inner">Expand</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-portlet__body" m-hidden-height="400" :style="bodyStyle">
            <div class="custom_scroll_long larger-text">
                <div class="tab-content">
                    <p><strong>{{ labels.specific_mentions }} : </strong> {{ specificMentions }}</p>

                    <div class="tab-pane active show" :id="'m_tabs_claim_1' + previewProduct.productId" role="tabpanel">
                        <h4>{{ labels.efficiency_title }}</h4>
                        <div v-if="claimsEfficiency.hit">
                            <div class="highlight-block alert-secondary">
                                <h6><strong>{{ labels.primary }}</strong></h6>
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.front }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_primary_pack_front')"></span>
                                    </div>
                                </div>

                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.back }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_primary_pack_back')"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="highlight-block alert-secondary">
                                <h6><strong>{{ labels.secondary }}</strong></h6>
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.front }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_secondary_pack_front')"></span>
                                    </div>
                                </div>
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.back }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_secondary_pack_back')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="highlight-block alert-secondary">
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.site_brand }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_on_brand_website')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="highlight-block alert-secondary">
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.others }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsEfficiency', 'efficiency_on_other_source')"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>{{ labels.no_product_claims }}</div>
                    </div>
                    <div class="tab-pane" :id="'m_tabs_claim_2' + previewProduct.productId" role="tabpanel">
                        <h4>{{ labels.security_title }}</h4>
                        <div v-if="claimsSecurity.hit">
                            <div class="highlight-block alert-secondary">
                                <h6><strong>{{ labels.primary }}</strong></h6>
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.front }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_primary_pack_front')"></span>
                                    </div>
                                </div>

                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.back }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_primary_pack_back')"></span>
                                    </div>
                                </div>

                            </div>
                            <div class="highlight-block alert-secondary">
                                <h6><strong>{{ labels.secondary }}</strong></h6>
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.front }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_secondary_pack_front')"></span>
                                    </div>
                                </div>

                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.back }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_secondary_pack_back')"></span>
                                    </div>
                                </div>

                            </div>
                            <div class="highlight-block alert-secondary">
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.site_brand }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_on_brand_website')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="highlight-block alert-secondary">
                                <div class="row claim-sect">
                                    <div class="col-2">
                                        <h6>{{ labels.others }} : </h6>
                                    </div>
                                    <div class="col-10">
                                        <span style="white-space: pre-line" v-html="showClaimValue('claimsSecurity', 'security_on_other_source')"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>{{ labels.no_product_claims }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: ['previewProduct', 'compareMode', 'keywordSearch'],
    data () {
        return {
            isOpen: true,
            claimsEfficiency: {
                hit: null,
                highlight: null
            },
            claimsSecurity: {
                hit: null,
                highlight: null
            }
        }
    },
    computed: {
        ...mapState({
            labels: state => state.labels,
            productIndex: state => state.products.productIndex
        }),
        bodyStyle () {
            if (!this.isOpen) {
                return 'display: none; overflow: hidden; padding-top: 0px; padding-bottom: 0px;'
            }
            return ''
        },
        specificMentions () {
            return this.previewProduct.specificMention ? this.previewProduct.specificMention : ' ' + this.labels.dash_symbol
        }
    },
    methods: {
        togglePortlet (status) {
            status === 'open' ? this.isOpen = status : this.isOpen = !this.isOpen
        },
        getClaimsById (keywordSearch) {
            var my = this
            this.productIndex
                .search({
                    query: keywordSearch,
                    facetFilters: [ ['isClaim:true'], ['productId:' + this.previewProduct.productId] ],
                    distinct: false,
                    attributesToRetrieve: ['claimsSecurity', 'claimsEfficiency'],
                    attributesToHighlight: ['claimsSecurity', 'claimsEfficiency']
                })
                .then(({ hits }) => {
                    if (hits.length) {
                        hits.forEach((hit) => {
                            my.readClaimResponse(hit, 'claimsEfficiency')
                            my.readClaimResponse(hit, 'claimsSecurity')
                        })
                    }

                    if (hits.length === 1 || !hits.length) {
                        this.getClaimsById('')
                    }
                })
        },
        readClaimResponse (hit, claimType) {
            if (hit.hasOwnProperty(claimType) && !this[claimType].hit) {
                this[claimType] = {
                    hit: hit,
                    highlight: {}
                }

                if (hit.hasOwnProperty('_highlightResult')) {
                    this[claimType].highlight = hit._highlightResult[claimType]
                }
            }
        },
        showClaimValue (type, claim) {
            return this[type].highlight[claim] ? this[type].highlight[claim].value : this[type].hit[claim]
        }
    },
    mounted () {
        if (this.previewProduct.hasClaims) {
            this.getClaimsById(this.keywordSearch)
        }
    }
}
</script>

<style>
    .highlight-block {
        align-items: stretch;
        padding: 1rem 2rem;
        margin: 0 0 50px 0;
        border-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Products/Preview/Claims.vue